export const HAZMAT_MESSAGES = {
  generalHazmat: 'checkout.all.hazmat.delivery.not.support',
  homeDelivery: 'checkout.all.hazmat.location.not.support',
  pickupPoint: 'checkout.all.hazmat.location.not.support',
  clickAndCollect: 'checkout.all.hazmat.location.not.support',
  deliverySpeed: 'checkout.all.hazmat.speed.not.support',
  cartUpdated: 'checkout.hazmat.order.updated',
  someItemsUndeliverable: {
    location: 'checkout.hazmat.location.not.supported',
    speed: 'checkout.hazmat.speed.not.supported',
  },
} as const
